import { useCallback } from 'react';

import { PlayerApiError } from '@/scenarios/legacy-player/types/instance';

import { PlayerError } from '../../../../error-boundary-context/error-map/map';
import { playerErrors } from '../../../hooks/controller/config';
import { useHandleAndLogError } from '../../../hooks/controller/use-handle-and-log-error';

export const useOnLoadingError = (type?: 'promo') => {
    const onLoadingError = useHandleAndLogError<PlayerApiError>({
        isFatal: useCallback((error) => error.isFatal, []),
        errorMessage: useCallback((error) => playerErrors.loadingError(error), []),
        errorToRaise: () => PlayerError.Loading,
    });

    if (type === 'promo') {
        return { onLoadingError: undefined };
    }

    return { onLoadingError };
};
